import { segmentProperties, segmentsTracking } from 'src/common/lib/tracker';

/**
 *
 * @param eventName
 * @param segmentProperties: {
  productTitle?: string;
  pageTitle: string;
  object: string;
  pageUrl?: string;
  successFlag?: boolean;
  resultValue: string;
  CTA: string;
  location: string;
  action: string;
  field: string;
}
 */
export const segmentTracking = (
  eventName: string,
  {
    pageTitle,
    object,
    resultValue,
    CTA,
    location,
    action,
    field,
  }: segmentProperties,
) => {
  // Define variables specific for the tracking this project
  const productTitle = 'Planning analytics ROI';
  const pageUrl = '/products/planning-analytics/pricing/';
  //
  segmentsTracking(eventName, {
    productTitle,
    pageTitle,
    pageUrl,
    object,
    successFlag: true,
    resultValue,
    CTA,
    location,
    action,
    field,
  });
};
